import React from 'react';
import Modal from "UI/Modal";
import Button from "UI/Button";

export default function ModalConfirm({open, onClose, onConfirm, title, children, danger = false, action = "Confirm"}) {

    return (
        <Modal open={open} onClose={onClose} className='max-w-md'>
            <Modal.Header>
                { title ? title : 'Are you sure?'}
            </Modal.Header>
            <Modal.Content className="text-sm text-gray-500">
                { children }
            </Modal.Content>
            <Modal.Footer>
                <Button type={danger ? 'danger' : 'primary'} onClick={onConfirm}>{action}</Button>
                <Button onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}
